// src/components/ServiceNow/TaskDashboardWidgets.jsx
import React from "react";
import {
  Grid,
  Card,
  CardContent,
  Box,
  Typography,
  Tooltip,
} from "@mui/material";
import {
  Warning as WarningIcon,
  Schedule as ScheduleIcon,
  CheckCircle as CheckCircleIcon,
} from "@mui/icons-material";

const TaskDashboardWidgets = ({ statistics }) => {
  if (!statistics) return null;

  const widgets = [
    {
      title: "Requires Attention",
      count: statistics.OverdueTasks + statistics.UnassignedTasks,
      icon: WarningIcon,
      color: "#EF5350",
      bgColor: "#FFEBEE",
      borderColor: "#EF5350",
      tooltip: `${statistics.OverdueTasks} overdue task${
        statistics.OverdueTasks !== 1 ? "s" : ""
      } and ${statistics.UnassignedTasks} unassigned task${
        statistics.UnassignedTasks !== 1 ? "s" : ""
      } need immediate attention`,
    },
    {
      title: "In Progress",
      count: statistics.InProgressTasks,
      icon: ScheduleIcon,
      color: "#3299FF",
      bgColor: "#E3F2FD",
      borderColor: "#3299FF",
      tooltip: `${statistics.InProgressTasks} task${
        statistics.InProgressTasks !== 1 ? "s are" : " is"
      } currently being worked on`,
    },
    {
      title: "Completed",
      count: statistics.CompletedTasks,
      icon: CheckCircleIcon,
      color: "#66BB6A",
      bgColor: "#E8F5E9",
      borderColor: "#66BB6A",
      tooltip: `${statistics.CompletedTasks} of ${statistics.TotalTasks} task${
        statistics.CompletedTasks !== 1 ? "s have" : " has"
      } been completed successfully`,
    },
  ];

  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      {widgets.map((widget, index) => {
        const Icon = widget.icon;
        return (
          <Grid item xs={12} md={4} key={index}>
            <Tooltip
              title={widget.tooltip}
              arrow
              placement="top"
              enterDelay={300}
            >
              <Card
                sx={{
                  borderLeft: `4px solid ${widget.borderColor}`,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  transition: "transform 0.2s, box-shadow 0.2s",
                  cursor: "pointer",
                  "&:hover": {
                    transform: "translateY(-2px)",
                    boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
                  },
                }}
              >
                <CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box>
                      <Typography
                        variant="body2"
                        sx={{
                          color: "#666",
                          mb: 1,
                          fontFamily: "Urbanist, Verdana, Arial, sans-serif",
                        }}
                      >
                        {widget.title}
                      </Typography>
                      <Typography
                        variant="h4"
                        sx={{
                          fontWeight: 700,
                          color: "#1a1a1a",
                          fontFamily: "Urbanist, Verdana, Arial, sans-serif",
                        }}
                      >
                        {widget.count} Task{widget.count !== 1 ? "s" : ""}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        width: 48,
                        height: 48,
                        borderRadius: "50%",
                        backgroundColor: widget.bgColor,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Icon sx={{ fontSize: 24, color: widget.color }} />
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Tooltip>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default TaskDashboardWidgets;
